// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: "brave-bites.firebaseapp.com",
  projectId: "brave-bites",
  storageBucket: "brave-bites.firebasestorage.app",
  messagingSenderId: "872539455192",
  appId: "1:872539455192:web:2f495317c1ceb683eca1ad",
  measurementId: "G-W5E2VYKDDE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };